import React, { useEffect, useMemo, useRef } from 'react'
import SlideContent from './SlideContent'
import useChannel from '../hooks/useChannel'
import { createConsumer } from '@rails/actioncable'
import { wsUrl } from '../consts/other'
import { HANDLE_WS_SLIDE_MESSAGE, SET_USER, SET_SCALE } from '../redux/slidesReducer'
import { useDispatch, useSelector } from 'react-redux'
import SlideTools from './SlideTools'
import Cursor from './Cursor'
import CursorMovementCapture from './CursorMovementCapture'
import LessonSlideCanvas from './LessonSlideCanvas'
import { RootReducer } from '../redux/rootReducer'
import { useParams } from 'react-router-dom'
interface Props {
  user: 'student' | 'tutor'
}

const LessonSlides = (props: Props) => {
  const actionCable = useMemo(() => createConsumer(wsUrl), [])
  const dispatch = useDispatch()
  const { subscribe, unsubscribe, send } = useChannel(actionCable)
  const { lessonId } = useParams()
  const containerRef = useRef<HTMLDivElement>(null)
  const scale = useSelector((state: RootReducer) => state.slidesReducer.scale)

  useEffect(() => {
    if (!containerRef.current) return
    const observer = new ResizeObserver(() => {
      const width = containerRef.current!.getBoundingClientRect().width
      const slideWidth = 800
      const scale = width / slideWidth
      dispatch(SET_SCALE({ scale }))
    })
    observer.observe(containerRef.current)
    return () => {
      observer.disconnect()
    }
  }, [dispatch])

  useEffect(() => {
    dispatch(SET_USER({ user: props.user }))
  }, [dispatch, props.user])

  useEffect(() => {
    const chanelSubscribe = async () => {
      subscribe(
        { channel: 'SlidesChannel', lesson_id: lessonId, role: 'tutor' },
        {
          received: (data) => {
            dispatch(HANDLE_WS_SLIDE_MESSAGE(data))
          }
        }
      )
    }
    chanelSubscribe()
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div ref={containerRef} className="flex-1">
      <SlideTools send={send} />
      <div className="relative">
        <div
          style={{ transform: `scale(${scale})` }}
          className="origin-top-left absolute top-0 left-0 w-[800px] h-[500px] bg-white rounded-md overflow-hidden">
          <div className="w-full h-full relative">
            <SlideContent />
            <Cursor />
            <LessonSlideCanvas />
            <CursorMovementCapture send={send} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LessonSlides
